module.exports = __webpack_public_path__ + "img/Jahwa-icon.96e3df8b.png";